import {api} from '@services/Api'

export const accountApi = api.injectEndpoints({
  endpoints: (build) => ({
    registerUser: build.mutation<any,any>({
      query: (args) => ({
        url: `covr/v1/user/register`,
        method: 'POST',
        body: args,
      }),
    }),
  })
});

export const {
  useRegisterUserMutation
} = accountApi;
